import { produce } from "immer";
import { Store } from "reducers/rootReducer";


/* STATE */
type State = {
  print: boolean;
}

const initialState: State = {
  print: false,
}

/* ACTIONS */
const OPEN_PRINT = "OPEN_PRINT_MENU";
const CLOSE_PRINT = "CLOSE_PRINT_MENU";

type Action =
    | { type: typeof OPEN_PRINT }
    | { type: typeof CLOSE_PRINT }

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case OPEN_PRINT:
        draft.print = true;
        break;
      case CLOSE_PRINT:
        draft.print = false;
        setTimeout(window.close, 0);
        break;
    }
  })
}

/* ACTION CREATORS */
export const openPrint = (): Action => ({
  type: OPEN_PRINT,
});

export const closePrint = (): Action => ({
  type: CLOSE_PRINT,
});

/* SELECTORS */
export const selectPrint = (app: Store) => app.print.print;
